
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 407 405","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M179.921.935C111.597 8.883 51.494 51.32 21.044 113.117-6.717 169.459-7.024 233.732 20.2 290.135c17.509 36.274 45.253 66.62 79.216 86.642 79.85 47.075 182.084 34.2 247.578-31.182 16.464-16.434 27.196-31.603 38.089-53.832 12.255-25.007 18.308-47.044 20.629-75.101 4.039-48.824-12.667-102.496-43.878-140.97-9.362-11.54-29.736-30.83-40.272-38.128-28.087-19.456-60.048-32.091-91.634-36.224-12.221-1.6-37.945-1.807-50.007-.405zM221.086 31.8c28.443 3.168 59.108 14.562 80.907 30.061 12.462 8.861 29.29 25.268 38.696 37.728 13.957 18.49 25.735 44.745 31.063 69.254 3.044 13.994 3.282 49.779.433 65.035-3.708 19.861-14.386 46.081-25.896 63.592-11.122 16.917-30.975 36.551-48.897 48.354-63.542 41.85-151.831 35.777-206.974-14.236-34.05-30.882-52.918-66.81-57.865-110.185-1.633-14.319-.629-39.458 2.093-52.396 6.487-30.836 21.37-60.051 42.131-82.71 36.115-39.413 91.605-60.369 144.309-54.497zm-26.145 69.289c-2.483 1.521-4.671 3.847-5.446 5.789-.956 2.394-1.394 13.226-1.671 41.3l-.375 38.054-37.669.511c-23.113.314-39.042.936-41.224 1.611-5.705 1.764-8.441 6.329-8.441 14.086 0 7.088 1.807 10.731 6.499 13.104 2.306 1.166 33.82 2.406 70.16 2.761l10.673.104.335 38.174c.383 43.756.396 43.831 8.015 47.513 5.562 2.687 9.006 2.697 14.504.041 7.843-3.791 7.744-3.216 8.1-47.055l.313-38.673 7.185-.102c74.901-1.06 74.472-1.019 78.804-7.578 2.588-3.918 2.504-12.715-.163-17.081-3.825-6.265-5.275-6.476-47.642-6.97l-38.168-.444-.322-39.053c-.275-33.516-.543-39.367-1.889-41.262-5.136-7.235-14.303-9.286-21.578-4.83z"}})])
          )
        }
      }
    